<template>
  <div>
    <md-sidenav @close="close()" class="md-right feedback-detail" ref="rightSidenav">
      <md-toolbar>
         <div class="md-toolbar-container">
            <h3 class="md-title" v-if="userOwner">Feedback a {{userOwner.displayName}}</h3>
            <div style="margin-left: 10px;">
              <md-icon class="icon-feed" v-if="feedback.tipo === 'autoeval'">person</md-icon>
              <md-icon class="icon-feed" v-if="feedback.tipo === 'companion'">swap_horiz</md-icon>
              <md-icon class="icon-feed" v-if="feedback.tipo === 'lider'">arrow_downward</md-icon>
            </div>
            <md-button @click.native="closeRightSidenav()" class="md-icon-button close-feedback">
                <md-icon>close</md-icon>
            </md-button>
         </div>
      </md-toolbar>

      <md-list class="form-question" v-if="feedback">
         <md-list-item v-for="preg in preguntas" :key="preg.key">
            <div class="md-list-text-container">
                <p class="md-center question">{{preg.question}}</p>
                <md-input-container md-inline>
                    <label v-if="!feedback.completed"></label>
                    <md-textarea class="answer" :readonly="feedback.completed !== undefined" v-model="preg.answer"></md-textarea>
                </md-input-container>
            </div>
         </md-list-item>
      </md-list>
      <div class="container-buttons" v-if="feedback.completed">
        <md-button v-if="!feedback.thanked && currentUser.email !== feedback.editor" class="md-raised md-primary" @click="thanks()">
          <md-icon>thumb_up</md-icon> Gracias!
        </md-button>
        <md-button class="md-raised md-primary" @click.native="closeRightSidenav">Ok</md-button>
      </div>
      <div class="container-buttons">
        <md-button v-if="feedback.owner === currentUser.email && !feedback.completed" class="md-raised md-primary" @click.native="openConfirm('delete-feedback')">Eliminar</md-button>
        <md-button v-if="feedback.editor === currentUser.email && !feedback.completed" class="md-raised md-primary" @click.native="guardar()">Guardar borrador</md-button>
        <md-button v-if="feedback.editor === currentUser.email && !feedback.completed" class="md-raised md-primary" @click.native="openConfirm('end-feedback')">Enviar</md-button>
      </div>
    </md-sidenav>

    <md-dialog-confirm
        :md-title="''"
        :md-content-html="'Enviar el Feedback?'"
        :md-ok-text="'Enviar'"
        :md-cancel-text="'Seguir editando'"
        @close="finalizar"
        ref="end-feedback">
    </md-dialog-confirm>

    <md-dialog-confirm
        :md-title="''"
        :md-content-html="'Se va a eliminar el Feedback, esta operacion no puede ser revertida, desea continuar?'"
        :md-ok-text="'Eliminar'"
        :md-cancel-text="'Seguir editando'"
        @close="eliminar"
        @
        ref="delete-feedback">
    </md-dialog-confirm>

    <md-dialog-alert
      :md-content="'Completar al menos un item antes de enviar el Feedback'"
      :md-ok-text="'Aceptar'"
      ref="alertEmpty">
    </md-dialog-alert>
  </div>
</template>

<script>
import FeedbacksService from '../services/feedbacks'
import FluxerService from '../services/fluxer'
import Router from '../router'
import NotificationsService from '../services/notifications'
import _ from 'lodash'

export default {
  name: 'feedback-detail',
  data () {
    return {
      feedback: ''
    }
  },
  computed: {
    currentUser: function () {
      if (!this.$route.params.currentUser) {
        return FluxerService.getCurrentUser()
      } else {
        return this.$route.params.currentUser
      }
    },
    userOwner: function () {
      let feedback = this.feedback
      return _.find(this.allFluxers, function (o) { return o.email === feedback.owner })
    }
  },
  mounted: function () {
    if (!this.$route.params.feedback) {
      this.$bindAsObject('feedback', FeedbacksService.getById(this.$route.params.id), null, () => this.$refs.rightSidenav.toggle())
    } else {
      this.feedback = this.$route.params.feedback
      this.$refs.rightSidenav.toggle()
    }
  },
  firebase: function () {
    return {
      preguntas: {
        source: FeedbacksService.getPreguntasById(this.$route.params.id)
      },
      allFluxers: FluxerService.getAll()
    }
  },
  methods: {
    close () {
      if (this.$route.name === 'feedback-detail') {
        Router.replace({name: 'inbox'})
      } else {
        Router.replace({name: 'mis-feedbacks'})
      }
    },
    closeRightSidenav () {
      this.$refs.rightSidenav.close()
    },
    guardar () {
      FeedbacksService.guardar(this.$route.params.id, this.preguntas)
      this.$refs.rightSidenav.close()
    },
    openConfirm (ref) {
      if (_.isEqual(ref, 'end-feedback')) {
        if (_.isEmpty(_.find(this.preguntas, function (p) { return p.answer.trim().length > 0 }))) {
          this.$refs['alertEmpty'].open()
          return false
        }
      }
      this.$refs[ref].open()
    },
    finalizar (type) {
      if (type === 'ok') {
        let feedback = this.feedback
        let editorUser = this.currentUser
        FeedbacksService.finalizar(this.feedback, this.currentUser, this.preguntas).then(() => {
          NotificationsService.enviarFeedback(feedback, editorUser)
          this.$refs.rightSidenav.close()
        })
        this.$router.replace('inbox')
      }
    },
    eliminar (type) {
      if (type === 'ok') {
        FeedbacksService.eliminar(this.feedback).then(() => {
          this.$refs.rightSidenav.close()
        })
      }
    },
    thanks () {
      FeedbacksService.agradecer(this.feedback).then(() => {
        this.$refs.rightSidenav.close()
        NotificationsService.agradecer(this.feedback, this.currentUser)
        this.$root.$emit('showMessages', 'Feedback de ' + this.feedback.editor + ' agradecido exitosamente')
      })
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
   .md-sidenav .md-sidenav-content {
        width: 50% !important;
    }

    .question {
        white-space: inherit !important;
    }

    .input-container {
        margin-top: -10px;
    }

    .container-buttons {
        padding: 30px 0;
        text-align: center;
    }

    .close-feedback {
        right: 0;
        position: absolute !important;
    }

    .icon-feed {
      font-size: 35px;
    }

    .answer {
      overflow: auto !important;
    }

    .feedback {
        overflow-x: hidden;
    }
</style>



// WEBPACK FOOTER //
// FeedbackDetail.vue?4ca67e2c